import { useMemo } from 'react';

import {
  type Enum,
  type UseAutocompleteEnumArgs,
  type UseAutocompleteEnumRes,
} from './autocomplete.types';

import { generateOptionsFromEnum } from './autocomplete.utils';
import useAutocompleteOptions from './useAutocompleteOptions';

const useAutocompleteEnum = <
  TEnum extends Enum,
  TMultiple extends boolean | undefined = undefined,
  TDisableClearable extends boolean | undefined = undefined,
>({
  includeValue,
  srcEnum,
  translationKey,
  ...args
}: UseAutocompleteEnumArgs<TEnum, TMultiple, TDisableClearable>): UseAutocompleteEnumRes<
  TEnum,
  TMultiple
> => {
  const options = useMemo(
    () => generateOptionsFromEnum({ includeValue, srcEnum, translationKey }).sort((a, b) => a.label.localeCompare(b.label)),
    [includeValue, srcEnum, translationKey],
  );

  return useAutocompleteOptions({
    data: options,
    ...args,
  });
};

export default useAutocompleteEnum;
